var map = {
	"./animate_avatar_ann.png": 48522,
	"./animate_avatar_annH.png": 69445,
	"./animate_avatar_ann_shadow.png": 33622,
	"./animate_avatar_dana.png": 53845,
	"./animate_avatar_david.png": 21962,
	"./animate_avatar_demi.png": 5921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73644;